import type { AttrDataType } from "#common/types/vault";

/** Domain accent colors (shared with Browse). */
export const DOMAIN_COLOR: Record<string, string> = {
  fundadmin: "#017989",
  dex: "#086290",
  fae: "#c8421e",
  agency: "#00614e",
};

/** Data types a steward/configurator can pick for a user-created or space-local attribute. */
export const EDITABLE_DATATYPES: AttrDataType[] = [
  "Text",
  "Number",
  "Date",
  "Yes/No",
  "Single-select",
  "Multi-select",
];

export const SELECT_DATATYPES: AttrDataType[] = ["Single-select", "Multi-select"];

// All 7 `AttrDataType` members, unlike `EDITABLE_DATATYPES` (a creation
// whitelist that excludes Reference). Space-local attributes may hold any of
// the 7, so a "Data type" filter built from the creation whitelist would
// silently hide Reference-typed rows whenever a value is unticked.
export const FILTERABLE_DATATYPES: AttrDataType[] = [
  "Text",
  "Number",
  "Date",
  "Yes/No",
  "Single-select",
  "Multi-select",
  "Reference",
];
